import { DatePicker, DatePickerProps } from 'antd';
import moment from 'moment';
import React from 'react';

interface StringDatePickerProps
  extends Omit<DatePickerProps, 'defaultValue' | 'value' | 'onChange'> {
  value?: string;
  onChange?: (value: string) => void;
}

// Component that saves a date as string to facilitate use with SearchParam component
const StringDatePicker: React.FC<StringDatePickerProps> = ({ value, onChange, ...props }) => {
  return (
    <DatePicker
      value={value ? moment(value.split('/').reverse().join('-')) : undefined}
      onChange={(value) => {
        onChange?.(value ? value.format('DD/MM/YYYY') : '');
      }}
      {...props}
    />
  );
};

export default StringDatePicker;
